import { faAccessibleIcon, faAmazon, faAmazonPay, faApple, faCcVisa, faChrome, faFacebook, faGoogle, faGoogleDrive, faInstagram, faLinkedinIn, faMailchimp, faPaypal, faShopify, faStripe, faTiktok, faWhatsapp, faWindows, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faAddressBook, faAddressCard, faAlarmClock, faAmpersand, faAperture, faArrowDown, faArrowDownLeft, faArrowDownRight, faArrowLeft, faArrowRight, faArrowsRotate, faArrowUp, faArrowUpArrowDown, faAsterisk, faAt, faBan, faBarcode, faBarcodeRead, faBars, faBed, faBell, faBlanket, faBlockQuestion, faBolt, faBook, faBooks, faBoxOpen, faBracketsCurly, faBracketsRound, faBraille, faBrakeWarning, faBriefcase, faBrightness, faBrush, faBuildingColumns, faBurgerGlass, faCalendarDays, faCamera, faCar, faCarBuilding, faChartLineUp, faChartSimple, faCheck, faCircleDown, faCircleEllipsisVertical, faCircleExclamation, faCircleInfo, faCircleMinus, faCirclePlus, faCircleQuestion, faCircleTrash, faCircleUp, faClock, faCoffeeBean, faCoffeePot, faCommentCaptions, faComments, faCopy, faCreditCard, faCube, faDeleteLeft, faDeleteRight, faDuck, faEllipsis, faEllipsisVertical, faEmptySet, faEnvelope, faEyeDropper, faEyeSlash, faFaceAngry, faFaceDotted, faFaceLaugh, faFaceSmile, faFaceSmileRelaxed, faFaceSmileWink, faFileArrowDown, faFileLines, faFileLock, faFiles, faFilm, faFilter, faFingerprint, faFolder, faFolderOpen, faFolderTree, faFont, faGamepad, faGear, faGears, faGift, faGlobe, faGlobeEurope, faGreaterThan, faGrid, faGrid2, faHand, faHandshake, faHashtag, faHeadset, faHeart, faIceCream, faImage, faImages, faInbox, faInfo, faKey, faLayerGroup, faLessThan, faLink, faList, faLocationDot, faLock, faLollipop, faMagnifyingGlass, faMicrophone, faMinus, faMoneyBill, faMoneyCheckDollar, faMotorcycle, faPalette, faPaperclip, faPaperPlane, faPencil, faPenNib, faPenToSquare, faPerson, faPersonCane, faPersonDress, faPhone, faPhotoFilm, faPlaneDeparture, faPlateUtensils, faPlus, faPrint, faPuzzle, faRectangleHistoryCirclePlus, faRotateLeft, faRotateRight, faScissors, faScribble, faShare, faShareAll, faShareFromSquare, faShareNodes, faSignature, faSliders, faSuitcase, faTag, faThumbsDown, faThumbtack, faTicket, faTrash, faTruck, faTruckFast, faUniversalAccess, faUser, faUserMagnifyingGlass, faUsers, faVideo, faVideoSlash, faWheelchair, faWifi, faXmark } from '@fortawesome/pro-light-svg-icons';
import { TwinDictionary } from '../globals/dictionary';

export const dictIcon: TwinDictionary = {
    'faCalendarDays': faCalendarDays,
    'faFileLines': faFileLines,
    'faFileArrowDown': faFileArrowDown,
    'faCopy': faCopy,
    'faEnvelope': faEnvelope,
    'faFolder': faFolder,
    'faFolderOpen': faFolderOpen,
    'faFolderTree': faFolderTree,
    'faInbox': faInbox,
    'faAddressCard': faAddressCard,
    'faBan': faBan,
    'faPaperPlane': faPaperPlane,
    'faBell': faBell,
    'faPhone': faPhone,
    'faHeadset': faHeadset,
    'faClock': faClock,
    'faMagnifyingGlass': faMagnifyingGlass,
    'faUserMagnifyingGlass': faUserMagnifyingGlass,
    'faPencil': faPencil,
    'faPenNib': faPenNib,
    'faBrush': faBrush,
    'faPenToSquare': faPenToSquare,
    'faScissors': faScissors,
    'faSignature': faSignature,
    'faGlobe': faGlobe,
    'faGlobeEurope': faGlobeEurope,
    'faLocationDot': faLocationDot,
    'faSuitcase': faSuitcase,
    'faBriefcase': faBriefcase,
    'faPrint': faPrint,
    'faAlarmClock': faAlarmClock,
    'faHeart': faHeart,
    'faPalette': faPalette,
    'faBlanket': faBlanket,
    'faBook': faBook,
    'faBooks': faBooks,
    'faAddressBook': faAddressBook,
    'faUser': faUser,
    'faUsers': faUsers,
    'faPerson': faPerson,
    'faPersonDress': faPersonDress,
    'faBed': faBed,
    'faAccessibleIcon': faAccessibleIcon,
    'faWheelchair': faWheelchair,
    'faPersonCane': faPersonCane,
    'faUniversalAccess': faUniversalAccess,
    'faBraille': faBraille,
    'faCommentCaptions': faCommentCaptions,
    'faHand': faHand,
    'faThumbsDown': faThumbsDown,
    'faHandshake': faHandshake,
    'faComments': faComments,
    'faCube': faCube,
    'faBoxOpen': faBoxOpen,
    'faMotorcycle': faMotorcycle,
    'faCar': faCar,
    'faCarBuilding': faCarBuilding,
    'faTruckFast': faTruckFast,
    'faTruck': faTruck,
    'faPlaneDeparture': faPlaneDeparture,
    'faMoneyBill': faMoneyBill,
    'faMoneyCheckDollar': faMoneyCheckDollar,
    'faCreditCard': faCreditCard,
    'faBuildingColumns': faBuildingColumns,
    'faTicket': faTicket,
    'faTag': faTag,
    'faLock': faLock,
    'faTrash': faTrash,
    'faAperture': faAperture,
    'faCamera': faCamera,
    'faFilm': faFilm,
    'faMicrophone': faMicrophone,
    'faVideo': faVideo,
    'faVideoSlash': faVideoSlash,
    'faImage': faImage,
    'faImages': faImages,
    'faFileLock': faFileLock,
    'faFiles': faFiles,
    'faRectangleHistoryCirclePlus': faRectangleHistoryCirclePlus,
    'faPhotoFilm': faPhotoFilm,
    'faGift': faGift,
    'faBlockQuestion': faBlockQuestion,
    'faPuzzle': faPuzzle,
    'faGamepad': faGamepad,
    'faDuck': faDuck,
    'faBolt': faBolt,
    'faPlateUtensils': faPlateUtensils,
    'faBurgerGlass': faBurgerGlass,
    'faCoffeePot': faCoffeePot,
    'faCoffeeBean': faCoffeeBean,
    'faIceCream': faIceCream,
    'faLollipop': faLollipop,
    'faScribble': faScribble,
    'faEyeDropper': faEyeDropper,
    'faThumbtack': faThumbtack,
    'faEyeSlash': faEyeSlash,
    'faFingerprint': faFingerprint,
    'faBrightness': faBrightness,
    'faFacebook': faFacebook,
    'faYoutube': faYoutube,
    'faInstagram': faInstagram,
    'faTiktok': faTiktok,
    'faShopify': faShopify,
    'faAmazon': faAmazon,
    'faLinkedinIn': faLinkedinIn,
    'faWhatsapp': faWhatsapp,
    'faGoogle': faGoogle,
    'faChrome': faChrome,
    'faGoogleDrive': faGoogleDrive,
    'faWindows': faWindows,
    'faApple': faApple,
    'faMailchimp': faMailchimp,
    'faCcVisa': faCcVisa,
    'faPaypal': faPaypal,
    'faAmazonPay': faAmazonPay,
    'faStripe': faStripe,
    'faBarcode': faBarcode,
    'faBarcodeRead': faBarcodeRead,
    'faChartLineUp': faChartLineUp,
    'faWifi': faWifi,
    'faCheck': faCheck,
    'faFilter': faFilter,
    'faSliders': faSliders,
    'faGear': faGear,
    'faGears': faGears,
    'faKey': faKey,
    'faPaperClip': faPaperclip,
    'faLink': faLink,
    'faBars': faBars,
    'faList': faList,
    'faGrid2': faGrid2,
    'faGrid': faGrid,
    'faLayerGroup': faLayerGroup,
    'faChartSimple': faChartSimple,
    'faHashtag': faHashtag,
    'faAsterisk': faAsterisk,
    'faAt': faAt,
    'faAmpersand': faAmpersand,
    'faBracketRound': faBracketsRound,
    'faBracketCurly': faBracketsCurly,
    'faFont': faFont,
    'faInfo': faInfo,
    'faCircleInfo': faCircleInfo,
    'faCircleQuestion': faCircleQuestion,
    'faCircleDown': faCircleDown,
    'faCircleUp': faCircleUp,
    'faCircleTrash': faCircleTrash,
    'faCircleExclamation': faCircleExclamation,
    'faBrakeWarning': faBrakeWarning,
    'faShare': faShare,
    'faShareAll': faShareAll,
    'faShareFromSquare': faShareFromSquare,
    'faShareNodes': faShareNodes,
    'faArrowRight': faArrowRight,
    'faArrowLeft': faArrowLeft,
    'faArrowUp': faArrowUp,
    'faArrowDown': faArrowDown,
    'faArrowUpArrowDown': faArrowUpArrowDown,
    'faArrowDownLeft': faArrowDownLeft,
    'faArrowDownRight': faArrowDownRight,
    'faPlus': faPlus,
    'faMinus': faMinus,
    'faCirclePlus': faCirclePlus,
    'faCircleMinus': faCircleMinus,
    'faEllipsis': faEllipsis,
    'faEllipsisVertical': faEllipsisVertical,
    'faCircleEllipsisVertical': faCircleEllipsisVertical,
    'faRotateRight': faRotateRight,
    'faRotateLeft': faRotateLeft,
    'faArrowsRotate': faArrowsRotate,
    'faDeleteLeft': faDeleteLeft,
    'faDeleteRight': faDeleteRight,
    'faLessThan': faLessThan,
    'faGreaterThan': faGreaterThan,
    'faEmptySet': faEmptySet,
    'faXmark': faXmark,
    'faFaceSmile': faFaceSmile,
    'faFaceSmileRelaxed': faFaceSmileRelaxed,
    'faFaceSmileWink': faFaceSmileWink,
    'faFaceLaugh': faFaceLaugh,
    'faFaceDotted': faFaceDotted,
    'faFaceAngry': faFaceAngry,
}
